import React from 'react';
import { observer } from 'mobx-react';
import CharacterListService from '../services/CharacterListService';
import CharacterListFilter from './CharacterListFilter';

const CharacterListFilterContainer = () => (
  <CharacterListFilter
    onSubmit={CharacterListService.handleFilter}
    onChange={CharacterListService.form.setValue}
    values={CharacterListService.form.getValues()}
    submitting={CharacterListService.fetch.fetching}
  />
);

export default observer(CharacterListFilterContainer);
